import React from 'react'
import { CalendarBlank } from '@phosphor-icons/react'
import { startOfDay } from 'date-fns'
import { useLocale } from 'src/lib/hooks/useLocal'
import { InlineDatePicker } from './InlineDatePicker'

interface AvailabilityDatesProps {
  startDate: Date | null
  endDate: Date | null
  onStartDateChange: (date?: Date) => void
  onEndDateChange: (date?: Date) => void
  onStartDateOpenChange?: (open: boolean) => void
  errors?: {
    startDate?: string
    endDate?: string
  }
  minDate?: Date
}

export const AvailabilityDates = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onStartDateOpenChange,
  errors = {},
  minDate
}: AvailabilityDatesProps) => {
  const { t } = useLocale()
  const today = startOfDay(new Date())
  // Valid till can never be earlier than the start date, nor in the past — whichever
  // of the two is later sets the floor, so an already-elapsed start date doesn't
  // leave a window of past, still-selectable dates.
  const endDateMinDate = minDate ?? (startDate && startDate > today ? startDate : today)

  return (
    <>
      <InlineDatePicker
        date={startDate}
        onChange={onStartDateChange}
        onOpenChange={onStartDateOpenChange}
        minDate={minDate || today}
        uiConfig={{
          label: t('discounts_v2.active_from'),
          icon: CalendarBlank
        }}
        error={errors.startDate}
      />

      <InlineDatePicker
        date={endDate}
        onChange={onEndDateChange}
        minDate={endDateMinDate}
        uiConfig={{
          label: t('discounts_v2.valid_till'),
          icon: CalendarBlank,
          placeholder: t('discounts_v2.set_date'),
          clearOptions: {
            shouldShowClearButton: true,
            handleClear: () => onEndDateChange(undefined)
          }
        }}
        error={errors.endDate}
      />
    </>
  )
}
